import mtnUrl from '@/assets/mtn.jpg';
import syriatelUrl from '@/assets/syriatel.jpg';
import networksUrl from '@/assets/networks.png';
import { str } from '@/utils/format';

export type NetworkKind = 'syriatel' | 'mtn' | 'mixed' | null;

export function detectNetwork(phoneOrCompany: unknown): NetworkKind {
  const raw = str(phoneOrCompany, '').toLowerCase();
  if (!raw) return null;
  if (raw.includes('syriatel') || raw.includes('سيريتل')) return 'syriatel';
  if (raw.includes('mtn') || raw.includes('ام تي ان')) return 'mtn';
  const digits = raw.replace(/\D/g, '');
  if (/^(099|098|093)/.test(digits)) return 'syriatel';
  if (/^(094|095|096)/.test(digits)) return 'mtn';
  return null;
}

export function NetworkBadge({
  company,
  phone,
  className = '',
}: {
  company?: unknown;
  phone?: unknown;
  className?: string;
}) {
  const kind = detectNetwork(company) ?? detectNetwork(phone) ?? 'mixed';
  const src = kind === 'syriatel' ? syriatelUrl : kind === 'mtn' ? mtnUrl : networksUrl;
  const label = kind === 'syriatel' ? 'سيريتل' : kind === 'mtn' ? 'MTN' : 'سيريتل و MTN';
  return (
    <span className={`network-logo-badge ${kind} ${className}`.trim()} aria-label={label}>
      <img src={src} alt={label} />
    </span>
  );
}
